import React, { useContext, useEffect, useState } from 'react';
import { DataContext } from "../context/DataContext";
import { Link, useNavigate } from 'react-router-dom'
const WithdrawalRequestPopup = ({ isOpen, onClose }) => {
    const { getAdminDashboardData, applicationData } = useContext(DataContext);
    const navigate = useNavigate();
    if (!isOpen) return null;
    const withdrawRequest = (applicationData && applicationData.withdrawRequests !== undefined) ? JSON.parse(applicationData.withdrawRequests) : [];

    const handle_click_request = () => {
        navigate(`/withdraw_requests`);
    }

    return (
        <div className="fixed inset-0  flex items-center h-full justify-center z-50">
            <div className='fixed z-[-1] inset-0 bg-gray-900 opacity-70' onClick={onClose}></div>

            <div className="relative bg-gradient-card border border-border/50  rounded-lg shadow-lg p-6 overflow-y-auto w-full h-full max-h-100 max-w-md mx-auto ">
                <button
                    onClick={onClose}
                    className="absolute top-3 right-3 text-gray-400 hover:text-white transition-colors"
                >
                    <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
                <h2 className="text-xl font-bold text-white mb-4">Withdrawal Request Details</h2>
                {withdrawRequest.length > 0 ? (
                    withdrawRequest.map(request => (
                        <div key={request.id} className="border border-border/50 rounded-lg shadow-xl p-6 my-6 w-full max-w-md mx-auto" onClick={handle_click_request}>
                            <div className="flex justify-between items-start mb-6">
                                <h2 className="text-2xl font-bold text-white">Withdrawal Request</h2>
                                <span className={`px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-wider ${request.status === 'APPROVED' ? 'bg-green-600 text-white' : request.status === 'REJECTED' ? 'bg-red-600 text-white' : 'bg-yellow-600 text-white'}`}>
                                    {request.status}
                                </span>
                            </div>
                            <div className="grid grid-cols-2 gap-x-6 gap-y-4 text-gray-300">
                                <div>
                                    <p className="font-semibold text-sm text-gray-400">Request ID</p>
                                    <p className="text-base font-medium">{request.id}</p>
                                </div>
                                <div>
                                    <p className="font-semibold text-sm text-gray-400">Artist</p>
                                    <p className="text-base font-medium">{request.artist_username}</p>
                                </div>
                                <div>
                                    <p className="font-semibold text-sm text-gray-400">Amount</p>
                                    <p className="text-base font-medium text-green-400">₹{request.amount}</p>
                                </div>
                                <div>
                                    <p className="font-semibold text-sm text-gray-400">Requested At</p>
                                    <p className="text-base font-medium">{new Date(request.requested_at).toLocaleString()}</p>
                                </div>
                                {request.rejection_reason && (
                                    <div className="col-span-2">
                                        <p className="font-semibold text-sm text-red-400">Rejection Reason</p>
                                        <p className="text-base font-medium text-gray-300">{request.rejection_reason}</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="text-center py-10">
                        <p className="text-gray-400 mb-4">No pending withdrawal requests.</p>
                        <Link to="/withdraw_requests" className="bg-primary hover:primary/10 text-white font-bold py-2 px-4 rounded transition-colors">
                            Go to Withdrawal Page
                        </Link>
                    </div>
                )}
           
            </div>
        </div>
    );
};

export default WithdrawalRequestPopup;
